import Model from '../model';





export default Model.extend( {

    defaults: {
        title: undefined,
    }

} );


// WEBPACK FOOTER //
// ./src/js/model/refbooks/workgroup.js